import { BoxConsumableStatus } from "@modules/boxConsumable/entities/boxConsumableType"
import { BoxConsumableDetailsDtoSchema } from "@modules/boxConsumable/gateway/boxConsumableApiDto"
import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import {
  BoxSubscriptionDetailsDtoSchema,
  BoxSubscriptionStatus,
} from "@modules/boxSubscription/gateway/boxSubscriptionApiDto"
import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { LightPromoCodeDtoSchema } from "@modules/promoCode/services/promoCodeDto"
import { z } from "zod"

export const BoxPurchaseDetailsDtoSchema = z.object({
  id: z.string(),
  purchaseDate: z.string().datetime(),
  price: PriceObjectDtoSchema.nullable(),
  status: z.nativeEnum(BoxConsumableStatus).or(z.nativeEnum(BoxSubscriptionStatus)),
  count: z.number().nullable(),
  initialCount: z.number().nullable(),
  offer: z.object({
    id: z.string(),
    name: z.string(),
    type: z.nativeEnum(BoxOfferType),
  }),
  usedPromoCode: LightPromoCodeDtoSchema.nullable(),
})

export const BoxPurchasesDtoSchema = z.object({
  subscriptions: z.array(BoxSubscriptionDetailsDtoSchema),
  consumables: z.array(BoxConsumableDetailsDtoSchema),
})

export type BoxPurchasesDetailsDto = z.infer<typeof BoxPurchaseDetailsDtoSchema>
export type BoxPurchasesDto = z.infer<typeof BoxPurchasesDtoSchema>
